'use strict';

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

var reduce = require('../iterable/reduce');

module.exports = function (_ref) {
  var _ref2 = _toArray(_ref),
      promise = _ref2[0],
      promises = _ref2.slice(1);

  var results = [];
  if (!promise) return Promise.resolve(results);
  return promises.reduce(function (chain, promise) {
    return chain.then(function (result) {
      results = results.concat(result);
      return promise();
    });
  }, promise()).then(function (result) {
    return results.concat(result);
  });
};


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/promise/chain.js
// module id = 2196
// module chunks = 37